import React, { useState } from 'react';
import { Award, Users, Building2, CheckCircle, User, Mail, Phone, Briefcase, Upload, Loader2, Send, MessageSquare, MapPin } from 'lucide-react';
import Footer from '../components/Footer';
import axios from 'axios';
import Swal from "sweetalert2";

const CareerPage = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    role: "",
    location: "",
    message: "",
    resume: null,
  });

  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  const positions = [
    { title: "Site Engineer", type: "Full-time", location: "Nagpur", tags: ["On-site", "Civil"] },
    { title: "Project Manager", type: "Full-time", location: "Nagpur", tags: ["Leadership", "Planning"] },
    {
      title: "Accountant",
      type: "Contract",
      location: "Remote",
      tags: ["Tally prime", "MS Excel"]
    }
  ];
  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (files) {
      const file = files[0];
      const maxSize = 2 * 1024 * 1024;
      if (file.size > maxSize) {

        setErrors((prev) => ({ ...prev, resume: "File size should not exceed 2 MB" }));
        setFormData((prev) => ({ ...prev, resume: null }));
        return;
      } else {

        setErrors((prev) => ({ ...prev, resume: "" }));
        setFormData((prev) => ({ ...prev, [name]: file }));
      }
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };


  const handleBlur = (e) => {
    const { name } = e.target;
    setTouched((prev) => ({ ...prev, [name]: true }));
    const error = validateField(name, formData[name]);
    setErrors((prev) => ({ ...prev, [name]: error }));
  };



  const validateField = (name, value) => {
    switch (name) {
      case 'fullName':
        return value ? (value.trim().length >= 2 ? '' : 'Name must be at least 2 characters') : 'Please enter your name';
      case 'email':
        if (!value) return 'Please enter your email';
        const re = /^\S+@\S+\.\S+$/;
        return re.test(value) ? '' : 'Enter a valid email address';
      case 'phone':
        return value ? (value.replace(/\D/g, '').length === 10 ? '' : 'Please enter a valid 10-digit mobile number') : 'Please enter your mobile number';
      case 'location':
        return value ? '' : 'Please enter your location';
      case 'message':
        return value ? '' : 'Please enter your message';
      case 'resume':
        return value ? '' : 'Please upload your resume';
      case 'role':
        return value ? '' : 'Please select a role';
      default:
        return '';
    }
  };


  const validateForm = () => {
    const newErrors = {};

    newErrors.fullName = formData.fullName ? (formData.fullName.trim().length >= 2 ? '' : 'Name must be at least 2 characters') : 'Please enter your name';
    newErrors.email = formData.email ? (/^\S+@\S+\.\S+$/.test(formData.email) ? '' : 'Enter a valid email') : 'Please enter your email';
    newErrors.phone = formData.phone ? (formData.phone.replace(/\D/g, '').length === 10 ? '' : 'Please enter valid 10-digit number') : 'Please enter your phone';
    newErrors.role = formData.role ? '' : 'Please select a role';
    newErrors.location = formData.location ? '' : 'Please enter your location';
    newErrors.message = formData.message ? (formData.message.trim().length >= 10 ? '' : 'Message must be at least 10 characters') : 'Please enter your message';
    newErrors.resume = formData.resume ? '' : 'Please upload your resume';

    return newErrors;
  };


  const handleSubmit = async (e) => {
    console.log("🚀 Submitting Application with data:", formData);

    e.preventDefault();
    console.log("Submitting:", formData);
    setTouched({
      fullName: true,
      email: true,
      phone: true,
      role: true,
      location: true,
      message: true,
      resume: true,
    });
    const newErrors = validateForm();
    setErrors(newErrors);
    if (Object.values(newErrors).some(err => err)) return;
    setLoading(true);
    try {
      const payload = new FormData();
      if (formData.resume) payload.append("files", formData.resume);

      const applicantDetails = {
        name: formData.fullName,
        email: formData.email,
        mobile: formData.phone,
        city: formData.location,
        message: formData.message || "",
      };
      payload.append("applicantDetails", JSON.stringify(applicantDetails));

      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/aaj-engineer/application-request`,
        payload
      );

      console.log("📤 Application Response:", response.data);


      if (response.data.status === "SUCCESS") {
        Swal.fire({
          title: "Application Submitted!",
          text: response.data.message,
          icon: "success",
          confirmButtonText: "OK",
        });


        setFormData({
          fullName: "",
          email: "",
          phone: "",
          role: "",
          location: "",
          message: "",
          resume: null,
        });
        setErrors({});
        setTouched({});
      } else {
        Swal.fire({
          title: "Error",
          text: response.data.message || "Something went wrong.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("❌ Application API Error:", error);

      Swal.fire({
        title: "Submission Failed!",
        text:
          error.response?.data?.message ||
          "Something went wrong. Please try again later.",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section
        className="relative pt-24 sm:pt-28 pb-16 sm:pb-20   text-white overflow-hidden"
        style={{
          backgroundImage: "url('/images/career 1.jpg')",
          backgroundSize: "100% 100%",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          height: '60vh',
        }}
      >
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-10 sm:top-20 right-10 sm:right-20 w-48 sm:w-96 h-48 sm:h-96 bg-white rounded-full blur-2xl"></div>
          <div className="absolute bottom-10 sm:bottom-20 left-10 sm:left-20 w-40 sm:w-64 h-40 sm:h-64 bg-white rounded-full blur-2xl"></div>
        </div>
        <div className="absolute inset-0 "></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 sm:mb-16">
            <p className="text-base sm:text-lg md:text-xl text-red-100 max-w-3xl sm:max-w-4xl mx-auto leading-relaxed">
            </p>
          </div>
        </div>
      </section>

      {/* Open Positions */}
      <section className="py-16 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
              Current{' '}
              <span className="bg-[#011321] bg-clip-text text-transparent">Openings</span>
            </h2>
            <p className="text-base sm:text-xl text-gray-600 max-w-2xl sm:max-w-3xl mx-auto">
              Join a fast-growing construction company focused on quality, safety and innovation.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {positions.map((job, idx) => (
              <div
                key={idx}
                className="group relative overflow-hidden rounded-2xl border-4 border-white-400 bg-white shadow-md hover:shadow-2xl transform-gpu transition-all duration-300 hover:-translate-y-1"
              >
                <div className="absolute -z-10 inset-0 bg-gradient-to-br from-white-400 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                <div className="p-6">
                  <div className="flex items-center justify-between mb-4">
                    <div className="inline-flex items-center gap-2 rounded-full bg-red-50 px-3 py-1 text-[#011321]">
                      <Building2 className="w-4 h-4" />
                      <span className="text-xs font-semibold tracking-wide">{job.type}</span>
                    </div>
                    <div className="text-xs text-gray-500">{job.location}</div>
                  </div>
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">{job.title}</h3>
                  <div className="flex flex-wrap gap-2 mb-4">
                    {job.tags.map((t, i) => (
                      <span key={i} className="text-xs px-2 py-1 rounded-full bg-gray-100 text-gray-700">{t}</span>
                    ))}
                  </div>
                  <button
                    onClick={() => {
                      setFormData((prev) => ({ ...prev, role: job.title }));
                      const el = document.getElementById('career-apply-form');
                      if (el && el.scrollIntoView) {
                        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                      }
                    }}
                    className="mt-auto inline-flex items-center justify-center rounded-lg bg-[#011321] px-4 py-2 text-white text-sm font-semibold shadow  transition-colors"
                  >
                    Apply Now
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Join Us */}
      <section className="py-16 sm:py-20 bg-gradient-to-br from-[#5f759b] to-[#5f759b]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 sm:mb-6">
              Why{' '}
              <span className="bg-[#011321] bg-clip-text text-white">Work With Us</span>
            </h2>
            <p className="text-base sm:text-xl text-gray-200 max-w-2xl sm:max-w-3xl mx-auto">
              Build iconic projects, grow your career, and be part of a winning team.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
            {[{
              icon: CheckCircle, title: 'Safety & Quality First', desc: 'We follow strict safety standards and quality processes on every site.'
            }, {
              icon: Users, title: 'People-First Culture', desc: 'Mentorship, learning, and a supportive environment for growth.'
            }, {
              icon: Award, title: 'Recognized Excellence', desc: 'Award-winning work that sets benchmarks in construction.'
            }, {
              icon: Building2, title: 'Challenging Projects', desc: 'From residential to commercial, work on diverse premium builds.'
            }].map((item, index) => {
              const Icon = item.icon;
              return (
                <div key={index} className="group p-6 sm:p-8 bg-white rounded-xl sm:rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-red-100 hover:border-red-300 transform hover:-translate-y-2">
                  <div className="w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-r from-[#011321] to-[#011321] rounded-lg sm:rounded-xl flex items-center justify-center mb-4 sm:mb-6 group-hover:scale-110 transition-transform duration-300">
                    <Icon className="w-6 h-6 sm:w-7 sm:h-7 text-white" />
                  </div>

                  <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2 sm:mb-4">{item.title}</h3>
                  <p className="text-sm sm:text-base text-gray-600 leading-relaxed text-justify">{item.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Application Form */}
      <section id="career-apply-form" className="py-16 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 sm:gap-16 items-start">
            <div>
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
                Apply{' '}
                <span className="bg-[#011321] bg-clip-text text-transparent">Now</span>
              </h2>

              <div className="relative rounded-2xl p-px bg-gradient-to-br from-white-500/30 via-white-300/20 to-transparent">
                <div className="rounded-2xl bg-white p-5 sm:p-6 shadow-lg border border-red-100">
                  <form onSubmit={handleSubmit} className="space-y-4">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Full Name</label>
                        <div className="relative">
                          <User className="absolute left-3 top-3.5 text-gray-400 w-5 h-5" />
                          <input
                            name="fullName"
                            value={formData.fullName}
                            onChange={(e) => {
                              const onlyText = e.target.value.replace(/[^A-Za-z\s]/g, "");
                              handleChange({ target: { name: "fullName", value: onlyText } });
                            }}
                            onBlur={handleBlur}
                            aria-invalid={touched.fullName && !!errors.fullName}
                            type="text"
                            className="w-full pl-12 pr-4 py-3 border border-[#011321] rounded-xl focus:ring-2 focus:ring-[#011321] focus:border-transparent outline-none transition-all duration-300"
                            placeholder="Enter your full name"
                          />
                        </div>
                        {touched.fullName && errors.fullName && <p className="mt-1 text-xs text-red-600">{errors.fullName}</p>}
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                        <div className="relative">
                          {/* <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" /> */}
                          <input name="email" value={formData.email} onChange={handleChange} onBlur={handleBlur} aria-invalid={touched.email && !!errors.email} type="email"

                            className="w-full pl-3 pr-4 py-3 border border-[#011321] rounded-xl focus:ring-2 focus:ring-[#011321] focus:border-transparent outline-none transition-all duration-300"
                            placeholder="your@email.com" />
                        </div>
                        {touched.email && errors.email && <p className="mt-1 text-xs text-red-600">{errors.email}</p>}
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Phone</label>
                      <div className="relative">
                        {/* <Phone className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" /> */}
                        <input
                          name="phone"
                          value={formData.phone}

                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, "");
                            if (value.length <= 10) {
                              handleChange({
                                target: {
                                  name: "phone",
                                  value: value,
                                },
                              });
                            }
                          }}
                          onBlur={handleBlur}
                          aria-invalid={touched.phone && !!errors.phone}
                          type="tel"
                          maxLength="10"
                          className="w-full pl-3 pr-4 py-3 border border-[#011321] rounded-xl focus:ring-2 focus:ring-[#011321] focus:border-transparent outline-none transition-all duration-300"

                          placeholder="9876543210"
                        />
                        {touched.phone && errors.phone && <p className="mt-1 text-xs text-red-600">{errors.phone}</p>}
                      </div>
                      <p className="text-xs text-gray-500 mt-1">Enter 10 digit mobile number only</p>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Location</label>
                        <div className="relative">
                          {/* Icon on the left */}
                          {/* <MapPin className="absolute left-3 top-3.5 text-gray-400 w-5 h-5" /> */}

                          {/* Input field */}
                          <input
                            name="location"
                            value={formData.location}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            aria-invalid={touched.location && !!errors.location}
                            type="text"
                            className="w-full pl-3 pr-4 py-3 border border-[#011321] rounded-xl focus:ring-2 focus:ring-[#011321] focus:border-transparent outline-none transition-all duration-300"
                            placeholder="Enter your location"
                          />
                        </div>

                        {/* Error message */}
                        {touched.location && errors.location && (
                          <p className="mt-1 text-xs text-red-600">{errors.location}</p>
                        )}
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Resume (PDF/PNG/JPG/JPEG)</label>
                        <label htmlFor="resume-upload" className="flex items-center justify-between w-full rounded-lg border border-dashed border-gray-300 px-4 py-2 bg-gray-50 hover:bg-gray-100 cursor-pointer transition-colors">
                          <span className="text-sm text-gray-600 truncate">{formData.resume ? formData.resume.name : 'Click to upload resume'}</span>
                          <Upload className="w-4 h-4 text-gray-500" />
                        </label>
                        <input
                          id="resume-upload"
                          name="resume"
                          onChange={handleChange}
                          type="file"
                          accept=".pdf,.png,.jpg,.jpeg"
                          className="hidden"
                        />
                        {errors.resume && <p className="text-red-500 text-xs mt-1">{errors.resume}</p>}
                      </div>

                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Message</label>
                      <div className="relative">
                        {/* <MessageSquare className="absolute left-3 top-4 text-gray-400 w-5 h-5" /> */}
                        <textarea
                          name="message"
                          value={formData.message}
                          onChange={handleChange}
                          rows="4"
                          className="w-full pl-3 pr-4 py-3 border border-[#011321] rounded-xl focus:ring-2 focus:ring-[#011321] focus:border-transparent outline-none transition-all duration-300 resize-none"
                          placeholder="Tell us about yourself"
                        ></textarea>
                      </div>
                      {touched.message && errors.message && <p className="mt-1 text-xs text-red-600">{errors.message}</p>}
                    </div>

                  <div className="flex items-center justify-between">
                  <p className="text-xs text-gray-500">By applying, you agree to our processing of your information.</p>                      <button
                        type="submit"
                        className="group inline-flex items-center justify-center w-full md:w-auto rounded-lg bg-[#011321] px-6 py-3 text-white text-sm font-semibold shadow hover:bg-[#022840] transition-colors"
                      >
                        {loading ? (
                          <>
                            <Loader2 className="w-5 h-5 animate-spin text-white mr-2" />
                            <span>Sending...</span>
                          </>
                        ) : (
                          <>
                            <Send className="w-5 h-5 text-white mr-1 group-hover:text-white group-hover:translate-x-1 transition-transform duration-300" />
                           <span>Submit Application</span>
                          </>
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div className="relative hidden lg:block flex justify-center items-center mt-20">
              <div className="absolute -inset-6 bg-gradient-to-br from-white-100 to-transparent rounded-3xl -z-10" />
              <div className="h-full w-full rounded-3xl overflow-hidden shadow-xl border border-white-100 mt-20">
                <img
                  src="/images/project.jpg"
                  alt="Careers at Madhuprabha Construction"
                  className="h-full w-full object-fill"
                />
              </div>
            </div>

          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default CareerPage;